import React, { useEffect, useState } from "react";
import {
  Checkbox,
  IconButton,
  Tooltip,
  Chip,
  Button,
  Grid,
  Autocomplete,
  TextField,
  Paper,
  Typography,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  Box,
  RadioGroup,
  FormControl,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { AxiosRequestConfig } from "axios";
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import requestMissingContexts, { determineConfig, determineConfigLong } from "../utils/GetContext";
import { useHistory } from "react-router-dom";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { AxiosError, AxiosResponse } from "axios";
import { useLocalStorage } from "../componentUtils/LocalStorage";
import { prettyPrintKPI } from "../components/request/CardKPIReco";
import {
  RestAPiReceipt,
  RestApiDefaultColumnOptions,
  GetDefaultColumnOptions,
  detectFilterChanges,
  getCustomerListData,
} from "../utils/CustomerListPageHelper";
import { Brightness1, Ballot, ArrowDownward, ArrowUpward, Clear, Bookmarks } from "@mui/icons-material";
import PageInPage from "../componentUtils/PageInPage";
import VendPrimeRequest from "./VendPrime/VendPrimeRequest";
import {
  GridFilterItem,
  GridFilterInputValue,
  DataGridPro,
  LicenseInfo,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridLinkOperator,
  GridSortModel,
  MuiEvent,
  GridColumnResizeParams,
  GridColDef,
  GridFilterModel,
} from "@mui/x-data-grid-pro";
import { formatDate, tryParseIntOrZero, removeLeadingZeros } from "../utils/Formatter";
import { GetStatusIcon, GetStatusBadge } from "../components/request/requestUtils";
import { getMaterialsList, getSalesOfficesAndRoutes } from "../utils/GetPlanning";
import { getRequestMaterialSwap } from "../utils/GetRequest";
import { getSettingsData,saveSettingsData} from "../utils/GetSettingsData";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import {checkForRole} from "../utils/GetAuth";
interface DeliveringPlant {
  deliveringPlant: string;
  name: string;
}

interface SalesOffice {
  salesOffice: string;
  name: string;
}

export interface TableAbstractionInputs {
  settingsKey:string;
  title?: string;
  // options?: TableAbstractionOptions;
  // data?: any[];
  // columns: TableAbstractionColumn[];
  error?:boolean;
  loading?:boolean;
  handleSaveProps?: any;
}
// eslint-disable-next-line max-len
LicenseInfo.setLicenseKey(
  "55a5960678d2f17e42032f031b42392aTz0xMjY1OTgsRT0xODA4MDQ5NjAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y"
);

/**
 * This will be used for
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @type {*}
 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cont: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0),
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    checkbox: {},
    root: {
      flexGrow: 1,
      marginBottom: theme.spacing(2),
    },
    dropdown: {
      marginTop: theme.spacing(2),
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
    },
    rootSpacing: {
      marginBottom: theme.spacing(2),
    },
    centerDiv: {
      textAlign: "center",
    },
    rightDiv: {
      textAlign: "right",
    },
    materialTable: {
      fontFamily: theme.typography.fontFamily,
    },
    spaceAll: {
      margin: theme.spacing(2),
      marginLeft: theme.spacing(0),
    },
    iconRed: {
      color: theme.palette.statusRed.main,
      fontSize: 13,
    },
    buttongroup: {
      marginBottom: theme.spacing(2),
    },
    iconButton: {
      padding: 0,
      margin: 0,
    },
    iconYellow: {
      color: theme.palette.statusYellow.main,
      fontSize: 13,
    },
    iconGreen: {
      color: theme.palette.statusGreen.main,
      fontSize: 13,
    },
    iconDisabled: {
      color: "LightGray",
      fontSize: 13,
    },
    downTrend: {
      color: theme.palette.statusRed.main,
    },
    upTrend: {
      color: theme.palette.statusGreen.main,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    buttonAllGroup: {
      paddingTop: "0px",
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      marginLeft: theme.spacing(1),
    },
    modalGrid: {
      marginTop: theme.spacing(2),
      alignItems: "center",
      justifyContent: "center",
      top: `50%`,
      left: `50%`,
    },
    modalTitle: {
      color: theme.palette.primary.main,
    },
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      border: `1px solid`,
      borderColor: theme.palette.border.main,
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2),
    },
    ulNoBullets: {
      listStyleType: "none",
      padding: 0,
      margin: 0,
    },
    titleBar: {
      margin: theme.spacing(0),
      padding: theme.spacing(0),
      textAlign: "center",
      width: "100%",
      fontWeight: "bolder",
      backgroundColor: theme.palette.action.selected,
      borderColor: theme.palette.primary.main,
      borderStyle: "solid",
      borderWidth: "1px",
    },
    rowStyle: {
      "& .Y": {
        backgroundColor: theme.palette.action.selected,
      },
    },
  })
);

/**
 * This will be used for arranging column sort order
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {any[]} arr
 * @param {number} old_index
 * @param {number} new_index
 * @returns {{}}
 */
function arrayMove(arr: any[], old_index: number, new_index: number) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
}

/**
 * This will be used for keeping checkboxes readonly
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {boolean} isChecked
 * @param {*} [handleClick=() => {}]
 * @returns {*}
 */
function ReadOnlyCheckBox(isChecked: boolean, handleClick: any = () => {}): any {
  return (
    <Checkbox checked={isChecked} name="active" color="primary" onClick={handleClick} />
  );
}

/**
 * This will be used for showing traffic light icons based on data for the columns like EFR, LFR etc...
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {(number | undefined)} value
 * @param {?number} [red]
 * @param {?number} [yellow]
 * @returns {*}
 */
// function TraficLightPercentage(value: number | undefined, red?: number, yellow?: number) {
//   const classes = useStyles();
//   let cName = value ? classes.iconGreen : classes.iconDisabled;
//   if (value && value <= (red || 50)) {
//     cName = classes.iconRed;
//   } else if (value && value <= (yellow || 70)) {
//     cName = classes.iconYellow;
//   }
//   return (
//     <div>
//       <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
//     </div>
//   );
// }

/**
 * This will be used for showing tooltip data
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @param {*} classes
 * @param {string} kpiName
 * @param {number} curVal
 * @param {number} predVal
 * @returns {*}
 */
function PrintKPI(classes: any, kpiName: string, curVal: number, predVal: number) {
  if (curVal < predVal) {
    return (
      <li>
        {kpiName}
        {`: `}
        {prettyPrintKPI(kpiName, curVal)}
        <ArrowUpward className={classes.upTrend} fontSize="small" />
        {prettyPrintKPI(kpiName, predVal)}
      </li>
    );
  } else if (curVal > predVal) {
    return (
      <li>
        {kpiName}
        {`: `}
        {prettyPrintKPI(kpiName, curVal)}
        <ArrowDownward className={classes.downTrend} fontSize="small" />
        {prettyPrintKPI(kpiName, predVal)}
      </li>
    );
  } else {
    return (
      <li>
        {kpiName}
        {`: `}
        {prettyPrintKPI(kpiName, curVal)}
      </li>
    );
  }
}

/**
 * This will be used for showing customer list component
 * @date 6/9/2022 - 5:03:21 PM
 * @author Srinadh Kanugala
 *
 * @export
 * @returns {*}
 */
export default function VendPrimePage(props: TableAbstractionInputs) {
  type MaterialSwapResponse = {
    customerNum:string,
    requestNum:number,
    materialFrom:string,
    salesOrg:string,
    materialTo:string,
    VPRStatus:string,
    message:string,
    vmTicketNumber:string,
  }
  
  const classes = useStyles();
  const history = useHistory();
  const [materialList, setMaterialList] = React.useState<any>([]);
  const [apidata, setApidata] = React.useState<RestAPiReceipt>();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [defaultColumnOptions, setDefaultColumnOptions] = React.useState<RestApiDefaultColumnOptions>({});
  const [codes, setCodes] = React.useState<any>();
  const key = (props.settingsKey)||'GTA';
  const [filterLS, setFilterLS] = React.useState<GridFilterModel>({
    items: [],
    linkOperator: GridLinkOperator.And,
  });
  const [selectedCustomerList, setSelectedCustomerList] = React.useState<Number[]>([]);
  const [sortLS, setSortLS] = useLocalStorage<GridSortModel>("SETTINGS.CLP_sort", []);
  const [columnOrder, setColumnOrder] = useLocalStorage<string[]>("SETTINGS.CLP_column_order", []);
  const [columnSizeLS, setColumnSizeLS] = useLocalStorage<{
    [key: string]: number;
  }>("SETTINGS.CLP_colsize", {});
  const [displayLS, setDisplayLS] = useLocalStorage<{ [key: string]: boolean }>("SETTINGS.CLP_displayableColumns", {
    master_route: true,
    name1: true,
    name3: true,
    active: true,
    equipment_num: true,
    bank_name: true,
    customer_num: true,
    asset_num: true,
    errors: true,
  });
  const [madeChange, setMadeChange] = useState(false);
  const [failedPullingData, setFailedPullingData] = useState(false);
  const [showTicket, setShowTicket] = React.useState<
    | {
        requestNum: number;
        deliveringPlant: string;
        customerNum: string;
        customerName: string;
      }
    | undefined
  >();
  const [page, setPage] = useLocalStorage<number>("SETTINGS.CLP_PageNumber", 0);
  const [pageRowCount, setPageRowCount] = useLocalStorage<number>("SETTINGS.CLP_PageRowCount", 50);
  const [swapMaterialBackDrop, setSwapMaterialBackDrop] = useState<boolean>(false);
  const [matSwapModel, setMatSwapModel] = useState<boolean>(false);
  const [modelRows, setModelRows] = useState<MaterialSwapResponse[]>([]);
  enum QueueType {
    accept = "ACCEPT",
    queue = "VP_QUEUE",
  }
  const [selectedQueue, setSelectedQueue] = useState<QueueType>(QueueType.queue);
const canSubmitTicket = checkForRole(clientId,salesOrg,'vp_approve_ticket');

  interface filterMaterialSwapTypes {
    deliveringPlantOptions: any;
    deliveringPlantValue: any;
    searchMaterial: any;
    replaceMaterial: any;
  }
  const [filterMaterialSwap, setFilterMaterialSwap] = useState<filterMaterialSwapTypes>({
    deliveringPlantOptions: null,
    deliveringPlantValue: null,
    searchMaterial: null,
    replaceMaterial: null,
  });

  /**
   * @Description defaultColumnOptions instead of local storage order
   * @author Srinadh
   * @param option:string
   */
  const SetCurrentColumnConfig = (option: string) => {
    if (defaultColumnOptions[option]) {
      setDisplayLS(defaultColumnOptions[option].CLP_displayableColumns);
      setColumnOrder(defaultColumnOptions[option].CLP_column_order);
    }
  };
  /**
   * @Description
   * @author Srinadh
   * @param value:SearchType
   */
  const handleQueueType = (value: QueueType) => {
    setSelectedQueue(value as QueueType);
  };

  // Getting keys of columns
  const defaultColumnOptionList = Object.keys(defaultColumnOptions);
  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        {defaultColumnOptionList.length === 1 ? (
          // TODO: add drop down if we have multiple options here. Currently do not.
          <Button color="primary" size="small" onClick={() => SetCurrentColumnConfig(defaultColumnOptionList[0])}>
            <Bookmarks /> {defaultColumnOptionList[0]}
          </Button>
        ) : (
          <div />
        )}
        <GridToolbarColumnsButton nonce={undefined} onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarFilterButton nonce={undefined} onResize={undefined} onResizeCapture={undefined} />
        <Button
          color="primary"
          size="small"
          onClick={() => setFilterLS({ items: [], linkOperator: GridLinkOperator.And })}
        >
          <Clear /> Clear Filters
        </Button>
        <GridToolbarDensitySelector nonce={undefined} onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  };
  /**
   * @Description for getting data from database based on filters, customer number, page etc...
   * @author Srinadh
   * @param customerNum:string
   */
  async function refreshRequest(customerNum: string) {
    const configReq: AxiosRequestConfig = {
      method: "GET",
      params: {
        clientId,
        salesOrg,
        customerNum,
      },
      url: `${BASE_URL}/api/request`,
    };

    return await AXIOS_INSTANCE(configReq)
      .catch((ae: AxiosError) => {})
      .then((res: AxiosResponse<any> | void) => {
        if (res && res.status < 400 && apidata) {
          const indx = apidata.out.findIndex((c) => c.customer_num === customerNum);
          if (indx >= 0) {
            let cur = apidata.out[indx];
            const req = res.data.request;
            cur = {
              ...cur,
              request_num: req.requestNum,
              sap_request_number: req.sapRequestNumber,
              request_status: req.requestStatus,
              requested_dt: req.requestedDt,
              request_max_dt: req.requestedDt,
            };
            setApidata({
              ...apidata,
              out: [...apidata.out.slice(0, indx), cur, ...apidata.out.slice(indx + 1)],
            });
          } else {
            console.error(`Unable to find index(${indx}) for customerNum(${customerNum}). can not update ticket data.`);
          }
        }
      });
  }
  const handleSwapMaterial = async () => {
    setSwapMaterialBackDrop(true);
    setMatSwapModel(true);
    const payload = {
      materialFrom: filterMaterialSwap.searchMaterial?.materialNum,
      materialTo: filterMaterialSwap.replaceMaterial?.materialNum,
      customers: selectedCustomerList,
      // salesOffice: filterMaterialSwap?.salesOfficeValue?.name,
      deliveringPlant: filterMaterialSwap?.deliveringPlantValue?.name,
      isQueue: selectedQueue === QueueType.queue,
    };
    getRequestMaterialSwap(salesOrg, payload)
      .then((res: any) => {
        if (res.status === 200) {
          const rows:MaterialSwapResponse[] = (res?.data?.matSwapRes) || [];
          setModelRows(rows);
        }
      })
      .catch((res: any)=>{
        setModelRows([]);
      })
      .finally(()=>{
        setSwapMaterialBackDrop(false);
        setSelectedQueue(QueueType.queue);
        setMadeChange(true);
      });
  };

  useEffect(() => {
    if (!apidata && !filterMaterialSwap.searchMaterial?.materialNum) {
      getSalesOfficesAndRoutes(salesOrg.toString()).then((v: any) => {
        const r_so: any[] = v?.plants;
        const r_rt: any[] = v?.routes;
        if (r_so && r_rt) {
          requestMissingContexts(["PLANTS"]).then((ctx) => {
            const contexts: any = ctx;
            var deliveringPlants: Array<DeliveringPlant> = [];
            for (var i = 0; i < r_so.length; i++) {
              const so = r_so[i].plant;
              const desc = so + ": " + determineConfig(contexts, "PLANTS", so || "");
              const deliveringPlant: DeliveringPlant = { deliveringPlant: so, name: desc };
              deliveringPlants.push(deliveringPlant);
            }
            setFilterMaterialSwap({
              ...filterMaterialSwap,
              deliveringPlantOptions: deliveringPlants,
            });
          });
        }
      });

      getMaterialsList(salesOrg).then((v: any) => {
        if (v && v.matDetails) setMaterialList(v.matDetails);
      });

      requestMissingContexts([
        "FSVSUBTRADECHANNEL",
        "FSVTRADECHANNEL",
        "SALESOFFICES",
        "PLANTS",
        "TRADECHANNEL",
        "TRADENAMES",
        "BRAND",
        "PACKSIZE",
        "PACKTYPE",
        "FLAVOUR",
        "BEVERAGECATEGORY",
        "vp_req_status",
      ]).then((v) => {
        setCodes(v);
      });

      GetDefaultColumnOptions(salesOrg).then((v) => {
        setDefaultColumnOptions(v.data);
      });
    } else if (madeChange) {
      setSelectedQueue(QueueType.queue);
      filterLS.items.push({
        columnField: "backend_material_num",
        operatorValue: "equals_eq",
        value: filterMaterialSwap.searchMaterial?.materialNum,
      });

      getCustomerListData(parseInt(clientId), salesOrg, filterLS, 0,[filterMaterialSwap?.deliveringPlantValue?.deliveringPlant]).then((ret) => {
        setApidata(ret.apiData);
        setFailedPullingData(ret.failedPullingData);
        setMadeChange(false);
      });
    }
  }, [madeChange]);

  useEffect(() => {
    //if (isLoaded) return;
      if(salesOrg){
  
           getSettingsData(salesOrg).then((v) => {
           // setSettingsTableData(v?.data);
           // For Displaying columns
    
            for (let i=0;i<v?.data?.length;i++){
            if(v?.data[i]?.colKey === `${key}_displayableColumns`){
              setDisplayLS(JSON.parse(v?.data[i]?.colVal));
            }
  
            // For filters
  
            if(v?.data[i]?.colKey === `${key}_filters`){
                setFilterLS(JSON.parse(v?.data[i]?.colVal));
            }
  
            // For coloumn order
  
            if(v?.data[i]?.colKey === `${key}_column_order`){
                setColumnOrder(JSON.parse(v?.data[i]?.colVal));
            }
  
            // For column size
  
            if(v?.data[i]?.colKey === `${key}_colsize`){
                setColumnSizeLS(JSON.parse(v?.data[i]?.colVal));
            }
  
            //
  
            if(v?.data[i]?.colKey === `${key}_sort`){
                setSortLS(JSON.parse(v?.data[i]?.colVal));
            }
  
           }
    
         });
        }
    }, []);

  const allFilterChoice = {
    code: "",
    text: "All",
    text_long: "All",
  };

  /**
   * @Description This is a callback method to change layout model from grid or list
   * @author Srinadh
   * @param params:GridFilterModel
   */
  const handleFilterModelChange = (params: GridFilterModel) => {
    setFilterLS(params);
    if (params.items.find((el) => el.columnField === "delivering_plant")) {
      if (params && detectFilterChanges(params.items, filterLS.items)) {
        const newBackendFilters = params.items.filter(
          (fmi: GridFilterItem) => fmi && (fmi.columnField || "").startsWith("BACKEND_")
        );
        const backendFilters = filterLS.items.filter(
          (fmi: GridFilterItem) => fmi && (fmi.columnField || "").startsWith("BACKEND_")
        );
        if (detectFilterChanges(backendFilters, newBackendFilters)) {
          setApidata(undefined);
          setMadeChange(true);
        }
      }
    } else {
      setFilterLS({ items: [], linkOperator: GridLinkOperator.And });
      setFilterMaterialSwap({
        ...filterMaterialSwap,
        deliveringPlantValue: null,
        searchMaterial: null,
        replaceMaterial: null,
      });
    }
  };

  function PaperComponent(props: any) {
    return (
      <Draggable handle="#dri-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    );
  }

  function saveTxSettingsData(value:string, columnName:string){
      const colKey = (key+columnName);
      if(salesOrg){
      saveSettingsData(salesOrg,colKey,value).then((v) => {
        });
      }
  }

  const handleColumnModelChange = (params: any) => {
    if (JSON.stringify(params) !== JSON.stringify(displayLS)){
      setDisplayLS(params);
      saveTxSettingsData(JSON.stringify(params), '_displayableColumns');
    }
  };
  const handleSortModelChange = (params: GridSortModel) => {
    /**
     * Only update state if there has actually been a change.
     * This fixes a maximum call stack size error.
     */
    if (JSON.stringify(params) !== JSON.stringify(sortLS)) setSortLS(params);
  };
  const handleColumnOrderChange = (params: any) => {
    setColumnOrder(arrayMove(columnOrder, params.oldIndex, params.targetIndex));
  };

  const handleColumnResize = (params: GridColumnResizeParams) => {
    columnSizeLS[params.colDef.field] = params.width;
    setColumnSizeLS(columnSizeLS);
  };

  const getSortedColumns = () => {
    const cols = getColumns();

    let colSrt = columnOrder;
    const colNamesAll = cols.map((c) => c.field);
    const colNamesNew = colNamesAll.filter((cn) => {
      return -1 === columnOrder.findIndex((co: any) => co === cn);
    });
    if (colNamesNew.length > 0) {
      colSrt = colSrt.concat(colNamesNew);
      setColumnOrder(colSrt);
    }

    const getSortIndex = (field: string) => {
      return colSrt.findIndex((co: any) => co === field);
    };
    const sortFunction = (a: GridColDef, b: GridColDef) => {
      return getSortIndex(a.field) - getSortIndex(b.field);
    };
    return cols.sort(sortFunction);
  };
  const defaultColumnConfig = (field?: string, width?: number) => {
    let ret: any = {
      disableColumnMenu: true,
    };
    if (field) {
      ret = {
        ...ret,
        field,
        hide: !displayLS[field],
        width: columnSizeLS[field] || width || 140,
      };
    }
    return ret;
  };
  const getColumns = () => {
    const cols: GridColDef[] = [
      {
        ...defaultColumnConfig("sales_office"),
        headerName: "Sales Office",
        renderCell: (params) =>
          `${params.value} - ${determineConfigLong(codes, "SALESOFFICES", params.value!.toString())}`,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "sales_office",
            InputComponent: (props: any) => (
              <GridFilterInputValue select disabled={true} SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns?.sales_office
                  .sort((a: any, b: any) => (a.code as string).localeCompare(b.code as string))
                  .map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text}
                    </option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("delivering_plant"),
        headerName: "Delivery Plant",
        renderCell: (params) =>
          `${params.value} - ${determineConfigLong(codes, "PLANTS", params.value!.toString())}`,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "delivering_plant",
            InputComponent: (props: any) => (
              <GridFilterInputValue select disabled={true} SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns?.delivering_plant
                  .sort((a: any, b: any) => (a.code as string).localeCompare(b.code as string))
                  .map((v: any) => (
                    <option value={v.code}>
                      {v.code} - {v.text}
                    </option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("customer_num"),
        headerName: "Customer #",
        renderCell: (params) => (
          <Chip
            label={params.value as any}
            variant="outlined"
            size="small"
            clickable={true}
            onClick={() => history.push(`/customer/${params.value as any}`)}
          />
        ),
      },
      {
        ...defaultColumnConfig("name1"),
        headerName: "Customer Name",
      },
      {
        ...defaultColumnConfig("name3"),
        headerName: "Location",
      },
      {
        ...defaultColumnConfig("master_route"),
        headerName: "Route",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "route",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.master_route.map((v: any) => (
                  <option value={v.text}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "route_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.master_route.map((v: any) => (
                  <option value={v.text}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("trade_name"),
        headerName: "Trade Name",
        renderCell: (params) => determineConfigLong(codes, "TRADENAMES", params.value!.toString()),
        filterable: false,
      },
      {
        ...defaultColumnConfig("trade_channel"),
        headerName: "Trade Channel",
        renderCell: (params) => determineConfig(codes, "FSVTRADECHANNEL", params.value!.toString()) || "",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "trade_channel",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.trade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "trade_channel_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.trade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("subtrade_channel"),
        headerName: "Subtrade Channel",
        renderCell: (params) => determineConfig(codes, "FSVSUBTRADECHANNEL", params.value!.toString()),
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "subtrade_channel",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.subtrade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "subtrade_channel_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.subtrade_channel.map((v: any) => (
                  <option value={v.code}>{v.text}</option>
                ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("active", 120),
        headerName: "Active",
        type: "boolean",
        renderCell: (params) => ReadOnlyCheckBox(params.value as any),
      },
      {
        ...defaultColumnConfig("suspension_begin_days"),
        headerName: "Suspension",
        description: "Suspension Status",
        renderCell: ({ value }) => {
          if (typeof value === "number") {
            if (value <= 0) {
              return (
                <div>
                  <Brightness1 fontSize="small" className={classes.iconRed} /> Suspend
                </div>
              );
            } else {
              return (
                <div>
                  <Brightness1 fontSize="small" className={classes.iconYellow} /> Future
                </div>
              );
            }
          } else return "";
        },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if (filterItem.value === "S") return (params.value || 1) <= 0;
                if (filterItem.value === "F") return (params.value || 0) > 0;
                if (filterItem.value === "N") return params.value === null;
                return true;
              };
            },
            label: "is",
            value: "Suspension",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value="N">None</option>
                <option value="F">Future</option>
                <option value="S">Suspend</option>
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("equipment_num", 85),
        headerName: "EQP",
        description: "Has Equipment Assigned",
        type: "boolean",
        renderCell: ({ value }) => ReadOnlyCheckBox((value as any) && (value as any).length > 0),
        filterable: true,
      },
      {
        ...defaultColumnConfig("asset_num"),
        headerName: "Asset #",
        filterable: true,
      },
      {
        ...defaultColumnConfig("equipment_model"),
        headerName: "Model",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "model",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_model
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "model_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_model
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("equipment_location", 200),
        headerName: "Equipment Location",
      },
      {
        ...defaultColumnConfig("equipment_status", 120),
        headerName: "EQP STS",
        description: "Equipment Status",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value === filterItem.value;
              };
            },
            label: "equals",
            value: "eqp_status",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_status
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return params.value !== filterItem.value;
              };
            },
            label: "not equals",
            value: "eqp_status_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.equipment_status
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.text}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("settlement_method", 90),
        headerName: "Stl M",
        description: "Settlement Method",
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return `${params.value}` === `${filterItem.value}`;
              };
            },
            label: "equals",
            value: "stl_method",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                {apidata?.dropdowns.settlement_method
                  .sort((a: any, b: any) => a.text.localeCompare(b.text))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("bank_name", 90),
        headerName: "Bank",
        renderCell: (params) => {
          if (params.value) {
            let custList: JSX.Element = <div />;
            const mdBankCustomers: any[] = apidata
              ? apidata.banks.find((b: any) => b.guid === params.row.bank_guid)?.mdBankCustomers || []
              : [];
            if (mdBankCustomers && mdBankCustomers.length > 0) {
              custList = (
                <div>
                  {mdBankCustomers.map((bc: any) => (
                    <div>
                      {bc.customerNum} {bc.mdCustomer.name1}
                    </div>
                  ))}
                </div>
              );
            }
            return (
              <Tooltip
                title={
                  <React.Fragment>
                    {`Bank: ${params.value}`}
                    <br />
                    {custList}
                  </React.Fragment>
                }
              >
                {/** Adding onclick event to bank checkbox for navigating to
                 * bank tab in customer list
                 */}
                {ReadOnlyCheckBox(true, () => history.push(`/customer/${params.row.customer_num as any}`, 1))}
              </Tooltip>
            );
          } else {
            {
              /** Adding onclick event to bank checkbox for navigating to
               * bank tab in customer list
               */
            }
            return ReadOnlyCheckBox(false, () => history.push(`/customer/${params.row.customer_num as any}`, 1));
          }
        },
      },
      {
        ...defaultColumnConfig("errors", 95),
        headerName: "Errors",
        type: "boolean",
        description: "Inconsistency Errors",
        renderCell: (params) => {
          const checked = params.row.customererrors || params.row.materialerrors;
          return ReadOnlyCheckBox(checked);
        },
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if ("ANY" === filterItem.value) {
                  return params.row.customererrors || params.row.materialerrors;
                } else if ("CST" === filterItem.value) {
                  return params.row.customererrors;
                } else if ("MAT" === filterItem.value) {
                  return params.row.materialerrors;
                }
                return true;
              };
            },
            label: "has",
            value: "errors_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={"ANY"}>Error</option>
                <option value={"CST"}>Customer Error</option>
                <option value={"MAT"}>Material Error</option>
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                if ("ANY" === filterItem.value) {
                  return !(params.row.customererrors || params.row.materialerrors);
                } else if ("CST" === filterItem.value) {
                  return !params.row.customererrors;
                } else if ("MAT" === filterItem.value) {
                  return !params.row.materialerrors;
                }
                return true;
              };
            },
            label: "has no",
            value: "errors_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={"ANY"}>Error</option>
                <option value={"CST"}>Customer Error</option>
                <option value={"MAT"}>Material Error</option>
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        ...defaultColumnConfig("effective_fill_rate", 125),
        headerName: "PFR@OOS",
        type: "number",
        description: "Projected Fill Rate @ Out Of Stock",
        renderCell: ({ value }) => {
          let cName = value ? classes.iconGreen : classes.iconDisabled;
            if (value && value <= 50) {
              cName = classes.iconRed;
            } else if (value && value <=  70) {
              cName = classes.iconYellow;
            }
            return (
              <div>
                <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
              </div>
            );
        }
      },
      {
        ...defaultColumnConfig("last_fill_rate", 125),
        headerName: "LFR",
        description: "Last Fill Rate",
        type: "number",
        renderCell: ({ value }) => {
          let cName = value ? classes.iconGreen : classes.iconDisabled;
            if (value && value <= 50) {
              cName = classes.iconRed;
            } else if (value && value <=  70) {
              cName = classes.iconYellow;
            }
            return (
              <div>
                <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
              </div>
            );
        }
      },
      {
        ...defaultColumnConfig("average_fill_rate", 125),
        headerName: "AFR",
        description: "Average Fill Rate",
        type: "number",
        renderCell: ({ value }) => {
          let cName = value ? classes.iconGreen : classes.iconDisabled;
            if (value && value <= 50) {
              cName = classes.iconRed;
            } else if (value && value <=  70) {
              cName = classes.iconYellow;
            }
            return (
              <div>
                <Brightness1 fontSize="small" className={cName} /> {value ? `${value}%` : `N/A`}
              </div>
            );
        }
      },
      {
        ...defaultColumnConfig("settlement_count", 90),
        headerName: "STLs",
        description: "Settlement Count",
        type: "number",
      },
      {
        ...defaultColumnConfig("last_visit_dt"),
        headerName: "Last Visit",
        type: "date",
      },
      {
        ...defaultColumnConfig("next_visit_dt_act"),
        headerName: "Next Visit",
        type: "date",
      },
      {
        ...defaultColumnConfig("request_num"),
        headerName: "VPR#",
        description: "VendPrime Request: Number",
        renderCell: (params) => {
          const value = params.value || "";
          if (!value || value === "") return <div />;

          if (params.row) {
            return (
              <Tooltip
                title={
                  <div>
                    Status: {determineConfig(codes, "vp_req_status", params.row.request_status) || GetStatusIcon}
                    <br />
                    Last Change: {params.row.request_max_dt ? formatDate(params.row.request_max_dt) : ""}
                  </div>
                }
              >
                <Chip
                  label={params.value}
                  variant="outlined"
                  icon={GetStatusIcon(params.row.request_status)?.icon}
                  size="small"
                  clickable={true}
                  onClick={() => {
                    setShowTicket({
                      requestNum: tryParseIntOrZero(`${value}`),
                      deliveringPlant: params.row.delivering_plant,
                      customerNum: params.row.customer_num,
                      customerName: params.row.name1,
                    });
                  }}
                />
              </Tooltip>
            );
          } else {
            return <div />;
          }
        },
      },
      {
        ...defaultColumnConfig("sap_request_number", 110),
        headerName: "Ticket #",
        description: "SAP Ticket Number",
        filterable: false,
      },
      {
        ...defaultColumnConfig("request_status", 200),
        headerName: "VPR Status",
        description: "VendPrime Request: Status",
        renderCell: (params) => <GetStatusBadge status={params.row.request_status} codes={codes} />,
      },
      {
        ...defaultColumnConfig("request_max_dt"),
        headerName: "VPR DT",
        description: "VendPrime Request: Last changed date",
        type: "date",
      },
      {
        ...defaultColumnConfig("daily_cogs", 110),
        headerName: "COGS/D",
        description: "COGS per day. Calculated at the time the last settlement reccord was processed.",
        type: "number",
      },
      {
        ...defaultColumnConfig("daily_revenue", 100),
        headerName: "Rev/D",
        description: "Revenue per day. Calculated at the time the last settlement reccord was processed.",
        type: "number",
      },
      {
        ...defaultColumnConfig("daily_net_revenue", 100),
        headerName: "Net/D",
        description: "Net revenue per day. Calculated at the time the last settlement reccord was processed.",
        type: "number",
      },
      {
        ...defaultColumnConfig("daily_opportunity", 100),
        headerName: "Op$/D",
        description:
          "Vend Prime Predicted Opportunity $ per day. This is periodically calculated by batch job, and gets recalculated when a new recomendation is run.",
        type: "number",
        renderCell: (params) => {
          if (!params.value || params.value === "") return <div />;
          const value = parseFloat((params.value || "").toString());
          if (params.row) {
            return (
              <Tooltip
                title={
                  <ul className={classes.ulNoBullets}>
                    {PrintKPI(
                      classes,
                      "Days until Stockout",
                      params.row.rrbe_days_stock_cur,
                      params.row.rrbe_days_stock_pred
                    )}
                    {PrintKPI(classes, "Vends/Day", params.row.rrbe_daily_vends_cur, params.row.rrbe_daily_vends_pred)}
                    {PrintKPI(classes, "Eff. Fill Rate", params.row.rrbe_efr_cur, params.row.rrbe_efr_pred)}
                    {PrintKPI(
                      classes,
                      "Revenue/Day",
                      params.row.rrbe_daily_revenue_cur,
                      params.row.rrbe_daily_revenue_pred
                    )}
                    {PrintKPI(classes, "GRLC/Day", params.row.rrbe_daily_grlc_cur, params.row.rrbe_daily_grlc_pred)}
                    <li>
                      Last Calculated:{" "}
                      {params.row.rrbe_last_change_dt ? formatDate(params.row.rrbe_last_change_dt) : ""}
                    </li>
                  </ul>
                }
              >
                <Chip
                  label={prettyPrintKPI("GRLC", value)}
                  variant="outlined"
                  icon={
                    value > 0 ? (
                      <ArrowUpward className={classes.upTrend} fontSize="small" />
                    ) : (
                      <ArrowDownward className={classes.downTrend} fontSize="small" />
                    )
                  }
                  size="small"
                  clickable={params.row.settlement_method === 5 && params.row.settlement_count > 1}
                />
              </Tooltip>
            );
          } else {
            return <div />;
          }
        },
      },
      {
        ...defaultColumnConfig("daily_sales", 100),
        headerName: "Sale/D",
        description: "Daily sales. This come from the VendSmart route planning dashboard.",
        type: "number",
      },
      {
        ...defaultColumnConfig("out_of_stock"),
        headerName: "OOS",
        description: "Out of stock",
        type: "boolean",
        renderCell: (params) => {
          const checked = params.value === true;
          return ReadOnlyCheckBox(checked);
        },
      },
      {
        headerName: "Brand (filter only)",
        field: "BACKEND_brand",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "brand_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.brand
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "brand_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.brand
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        headerName: "Pack Size (filter only)",
        field: "BACKEND_pack_size",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "pack_size_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_size
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "pack_size_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_size
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        headerName: "Pack Type (filter only)",
        field: "BACKEND_pack_type",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "pack_type_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_type
                  .sort((a: any, b: any) => (a.text_long as string).localeCompare(b.text_long as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text_long}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "pack_type_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.pack_type
                  .sort((a: any, b: any) => (a.text_long as string).localeCompare(b.text_long as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text_long}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        headerName: "Flavor (filter only)",
        field: "BACKEND_flavor",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "flavor_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.flavor
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "flavor_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.flavor
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
      {
        headerName: "Beverage Category (filter only)",
        field: "BACKEND_beverage_category",
        disableColumnMenu: true,
        hideSortIcons: true,
        hide: true,
        filterOperators: [
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "equals",
            value: "beverage_category_eq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.beverage_category
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
          {
            getApplyFilterFn: (filterItem: GridFilterItem) => {
              return (params): boolean => {
                return true;
              };
            },
            label: "not equals",
            value: "beverage_category_neq",
            InputComponent: (props: any) => (
              <GridFilterInputValue select SelectProps={{ native: true }} {...props}>
                <option value={allFilterChoice.code}>{allFilterChoice.text}</option>
                {apidata?.dropdowns.beverage_category
                  .sort((a: any, b: any) => (a.text as string).localeCompare(b.text as string))
                  .map((v: any) => (
                    <option value={v.code}>{v.text}</option>
                  ))}
              </GridFilterInputValue>
            ),
          },
        ],
      },
    ];
    return cols;
  };
  const filterMaterialList = (matList: any, key: string) => {
    if (key === "replaceMaterial") {
      return matList?.filter((item: any) => item.description !== filterMaterialSwap?.replaceMaterial?.description);
    } else {
      return matList?.filter((item: any) => item.description !== filterMaterialSwap?.searchMaterial?.description);
    }
  };
  const modelColumns: GridColDef[] = [
    {
      field: "customerNum",
      headerName: "Customer",
      editable: false,
      width: 125,
    },
    {
      field: "requestNum",
      headerName: "VP Request",
      sortable: true,
      width: 125,
    },
    {
      field: "vmTicketNumber",
      headerName: "SAP Ticket",
      sortable: true,
      width: 125,
    },
    {
      field: "VPRStatus",
      headerName: "VPR Status",
      editable: false,
      renderCell: (params) => <GetStatusBadge status={params.row.VPRStatus} codes={codes} />,
      width: 150,
    },
    {
      field: "message",
      headerName: "Message",
      editable: false,
      width: 500,
    },
    {
      field: "deliveringPlant",
      headerName: "Delivery Plant",
      editable: true,
      width: 200,
    },
  ];
  return (
    <div>
      <ResponsiveDrawer title="Material Swapper">
        <Paper className={classes.cont}>
          <Grid
            container
            className={classes.buttonAllGroup}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Grid item lg={2} md={2} xl={2} xs={2}>
              <Autocomplete
                id="delivering-plant"
                options={filterMaterialSwap?.deliveringPlantOptions || []}
                value={filterMaterialSwap?.deliveringPlantValue}
                getOptionLabel={(option: any) => `${option.name}`}
                autoHighlight
                onChange={(_, newMat) => {
                  if (!newMat) {
                    setFilterMaterialSwap({
                      ...filterMaterialSwap,
                      deliveringPlantValue: newMat,
                      searchMaterial: null,
                      replaceMaterial: null,
                    });
                    setFilterLS({ items: [], linkOperator: GridLinkOperator.And });
                  } else {
                    setFilterMaterialSwap({ ...filterMaterialSwap, deliveringPlantValue: newMat, searchMaterial: null,
                      replaceMaterial: null });
                    setFilterLS({
                      items: [
                        {
                          columnField: "delivering_plant",
                          operatorValue: "delivering_plant",
                          value: newMat.deliveringPlant,
                        },
                      ],
                      linkOperator: GridLinkOperator.And,
                    });
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && (event.target as any).value) {
                    const newMat = (event.target as any).value;
                    setFilterMaterialSwap({ ...filterMaterialSwap, deliveringPlantValue: newMat });
                    setFilterLS({
                      items: [
                        {
                          columnField: "delivering_plant",
                          operatorValue: "delivering_plant",
                          value: newMat.deliveringPlant,
                        },
                      ],
                      linkOperator: GridLinkOperator.And,
                    });
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Delivery Plant" helperText="Select Delivery Plant" variant="standard" />
                )}
              />
            </Grid>

            <Grid item lg={3} md={3} xl={3} xs={3}>
              <Autocomplete
                id="search-selected"
                options={filterMaterialList(materialList, "replaceMaterial")}
                value={filterMaterialSwap.searchMaterial}
                getOptionLabel={(option: any) => `${parseInt(option.materialNum)}-${option.description}`}
                autoHighlight
                onChange={(_, newMat) => {
                  if (!newMat) {
                    setFilterMaterialSwap({
                      ...filterMaterialSwap,
                      searchMaterial: newMat,
                      replaceMaterial: null,
                    });
                  } else {
                    setFilterMaterialSwap({ ...filterMaterialSwap, searchMaterial: newMat });
                    setApidata(undefined);
                    setMadeChange(true);
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && (event.target as any).value) {
                    const newMat = (event.target as any).value;
                    setFilterMaterialSwap({ ...filterMaterialSwap, searchMaterial: newMat });
                    setApidata(undefined);
                    setMadeChange(true);
                  }
                }}
                disabled={!filterMaterialSwap.deliveringPlantValue}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search Material"
                    helperText="Select material to be replaced"
                    variant="standard"
                  />
                )}
              />
            </Grid>
            <Grid item lg={3} md={3} xl={3} xs={3}>
              <Autocomplete
                id="replace-selected"
                options={filterMaterialList(materialList, "searchMaterial")}
                getOptionLabel={(option: any) => `${parseInt(option.materialNum)}-${option.description}`}
                value={filterMaterialSwap.replaceMaterial}
                autoHighlight
                onChange={(_, newMat) => {
                  setFilterMaterialSwap({ ...filterMaterialSwap, replaceMaterial: newMat });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" && (event.target as any).value) {
                    const newMat = (event.target as any).value;
                    setFilterMaterialSwap({ ...filterMaterialSwap, replaceMaterial: newMat });
                  }
                }}
                disabled={!filterMaterialSwap.searchMaterial}
                renderInput={(params) => (
                  <TextField
                  {...params}
                  variant="standard"
                  label="Replace Material"
                  helperText="Select material to replace"
                  />
                  )}
                  />
            </Grid>

            <Grid item lg={2} md={2} xl={2} xs={2}>
              <div>
              {/* className={classes.rightDiv} */}
                <FormControl>
                  <RadioGroup
                    value={selectedQueue}
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      control={<Radio />}
                      value={QueueType.accept}
                      disabled={!canSubmitTicket || !filterMaterialSwap.replaceMaterial || selectedCustomerList.length === 0}
                      label="Create Ticket"
                      onChange={() => handleQueueType(QueueType.accept)}
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value={QueueType.queue}
                      disabled={!filterMaterialSwap.replaceMaterial || selectedCustomerList.length === 0}
                      label="Send to Queue"
                      onChange={() => handleQueueType(QueueType.queue)}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Grid>
            <Grid item lg={2} md={2} xl={2} xs={2}>
              <Button
                className={classes.buttongroup}
                variant="text"
                size="large"
                color="primary"
                onClick={handleSwapMaterial}
                disabled={!filterMaterialSwap.replaceMaterial || selectedCustomerList.length === 0}
              >
                Swap Materials
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {filterMaterialSwap?.deliveringPlantValue && filterMaterialSwap?.searchMaterial && (
          <div className={classes.materialTable}>
            <div style={{ height: window.innerHeight - 80 - 150}}>
              <Typography className={classes.titleBar} variant="h5" color="primary">
                Material Swap
              </Typography>
              <DataGridPro
                key="customer-xgrid"
                filterModel={filterLS}
                sortModel={sortLS}
                error={failedPullingData ? true : undefined}
                rowsPerPageOptions={[50, 100, 250, 500, 1000]}
                onPageSizeChange={(params: any) => {
                  setPageRowCount(params.pageSize);
                }}
                columnBuffer={20}
                pagination
                page={page}
                onPageChange={(params: any) => {
                  setPage(params.page);
                }}
                components={{
                  Toolbar: CustomToolbar,
                }}
                pageSize={pageRowCount}
                onFilterModelChange={handleFilterModelChange}
                onSortModelChange={handleSortModelChange}
                onColumnVisibilityModelChange={handleColumnModelChange}
                onColumnOrderChange={handleColumnOrderChange}
                onColumnWidthChange={handleColumnResize}
                checkboxSelection
                getRowClassName={(params) => `rowStyle .${params.row.request_status}`}
                onSelectionModelChange={(ids, v) => {
                  const mapToArray = Array.from(v.api!.getSelectedRows().values());
                  var customerList: Number[] = [];
                  mapToArray.forEach((element: any) => {
                    customerList.push(element.customer_num);
                  });
                  setSelectedCustomerList(customerList.sort());
                }}
                density={"compact"}
                loading={!(apidata && apidata.out)}
                rows={(apidata && apidata.out && apidata.out.length > 0 && apidata.out) || []}
                columns={getSortedColumns()}
                isRowSelectable={(params) =>
                  ["O", "I", "M", "VP_ACCEPT", "VP_QUEUE", "VP_REQUEST", "VP_SUBMIT", "VP_DRAFT"].indexOf(
                    params.row.request_status
                  ) === -1
                }
              />
            </div>
          </div>
        )}
      </ResponsiveDrawer>
      <PageInPage
        onClose={() => {
          refreshRequest((showTicket && showTicket.customerNum) || "");
          setShowTicket(undefined);
        }}
        title={`${showTicket ? showTicket.deliveringPlant : ""} (${showTicket ? showTicket.customerNum : ""}) ${
          showTicket ? showTicket.customerName : ""
        }`}
        isOpen={showTicket ? true : false}
        content={
          <VendPrimeRequest
            requestNum={showTicket ? showTicket.requestNum : 0}
            onClose={() => {
              setShowTicket(undefined);
            }}
          />
        }
      />

      {/* // Model Swap Mat Table */}
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={swapMaterialBackDrop}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        aria-labelledby="dri-title"
        PaperComponent={PaperComponent}
        open={matSwapModel && !swapMaterialBackDrop}
      >
        <DialogTitle id="dri-title" style={{ cursor: "move" }}>
          Material Swap Results 
          ( {removeLeadingZeros(filterMaterialSwap?.searchMaterial||'')} 
          to {removeLeadingZeros(filterMaterialSwap?.replaceMaterial||'')} )
          <IconButton
            aria-label="close"
            onClick={() => setMatSwapModel(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "primary",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box sx={{ height: 520, width: "100%" }}>
          <DataGridPro
            rows={modelRows.map((r,id)=>{
              return{
                ...r,
                id,
                vmTicketNumber:removeLeadingZeros(r.vmTicketNumber),
                materialFrom:removeLeadingZeros(r.materialFrom),
                materialTo:removeLeadingZeros(r.materialTo),
              }})}
            columns={modelColumns}
            pageSize={5}
            rowsPerPageOptions={[5]}
          />
        </Box>
      </Dialog>
    </div>
  );
}
